import { createSelector } from 'reselect';
const getNavItems = state => state.navItems;
export const selectHasGlobalHomeAccess = createSelector([getNavItems], navItems => !!navItems.byId['global-home']);